export function init() {
    const printButtons = document.querySelectorAll<HTMLButtonElement | HTMLAnchorElement>('.wp-block-button.is-action-print .wp-element-button')

    const printClickHandler = function(event: Event) {
        window.print();
    }

    const setupPrintButton = function(printButton: HTMLButtonElement | HTMLAnchorElement) {
        printButton.addEventListener('click', printClickHandler)
    }

    printButtons.forEach(setupPrintButton)
}
